import { Link } from "react-router-dom";
import { useAuthStore } from "../../auth/hooks";
import { SecretaryLayout } from "../Layout";
import { DoctorsCard, AddPatientCard } from "../components";
import { UploadCsvCard } from "../components/patients/UploadCsvCard";
import { ipsIds } from "../data";
import { AddPatientCardV2 } from "../components/cards";

export const AddPatientsPage = () => {
  // Datos de hooks ----------------------------------------//
  const {
    // Props
    user,
  } = useAuthStore();

  const isHospitalSogamoso =
    user?.ips?.id && ipsIds[user.ips.id] === "HOSPITAL_REGIONAL_DE_SOGAMOSO";
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <SecretaryLayout>
      <div className="container-fluid">
        <div className="layout-specing">
          <div className="d-md-flex justify-content-between mb-2">
            <h5 className="mb-0">Agregar nuevo paciente</h5>
            <nav
              aria-label="breadcrumb"
              className="d-inline-block mt-4 mt-sm-0"
            >
              <ul className="breadcrumb bg-transparent rounded mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/secretary/dashboard">Gosafe</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/secretary/patients">Pacientes</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Agregar paciente
                </li>
              </ul>
            </nav>
          </div>

          <div className="row gy-4">
            <div className="col-lg-8">
              <div className="vstack gap-4">
                {isHospitalSogamoso && <UploadCsvCard />}
                <AddPatientCard />
              </div>
            </div>

            <div className="col-lg-4">
              <DoctorsCard />
            </div>

            {/*<div className="col-lg-4">
              <AddPatientCardV2 />
            </div>*/}
          </div>
        </div>
      </div>
    </SecretaryLayout>
  );
};
